<template>
	<button @click="handleClick">
		<slot />
	</button>
</template>

<script>
import EventBus from '@/utils/event-bus';

export default {
	props: {
		modalId: {
			type: String,
			required: true,
		},
	},
	methods: {
		handleClick() {
			EventBus.$emit( 'close:menu', false );
			EventBus.$emit( 'toggle:modal', this.modalId );
		},
	},
};
</script>
